import React, { useState } from 'react';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import {
  patchFormContent,
  postFormContent,
} from '../../../../../services/forms/formContentService';
import SimpleLoader from '../../../../../components/Loader/SimpleLoader';
import { useFormEdit } from '../FormEditContext';

// order — позиция нового вопроса (с 1): бэк вставляет его туда и сдвигает
// остальные. Без order (кнопка у заголовка формы) — в начало.
const FormToolbar = ({ update, uuid, order = 1 }) => {
  const [isCreating, setIsCreating] = useState(false);
  const { reportError } = useFormEdit();
  return (
    <div className='absolute -right-10'>
      <div className='flex flex-col rounded-lg bg-white p-1'>
        {isCreating ? (
          <div className='relative'>
            <SimpleLoader className='h-5' />
          </div>
        ) : (
          <PlusCircleIcon
            className='h-5 cursor-pointer'
            title={'add question'} // to translate
            onClick={() => {
              setIsCreating(true);
              postFormContent({
                form: uuid,
                test_type: 'SELECTONE',
                order: order,
              })
                ?.then((res) => {
                  patchFormContent(res.uuid, { order: order })
                    ?.then(() => {
                      update()?.finally(() => setIsCreating(false));
                    })
                    ?.catch((err) => {
                      setIsCreating(false);
                      reportError(err);
                    });
                })
                ?.catch((err) => {
                  setIsCreating(false);
                  reportError(err, 'Не удалось добавить вопрос');
                });
            }}
          />
        )}
      </div>
    </div>
  );
};

export default FormToolbar;
